interface R2Config {
  baseUrl: string;
}

// R2 Configuration
const R2_BASE_URL = 'https://pub-97e3ca4bae034008a785bb9c49b21677.r2.dev';

// Function to generate R2 URLs
export const getR2Url = (path: string): string => {
  // Remove any leading slashes to prevent double slashes
  const cleanPath = path.replace(/^\/+/, '');
  return `${R2_BASE_URL}/${cleanPath}`;
};

// Function to get audio file URL
export const getAudioUrl = (path: string): string => {
  // The path should already include the megapack version (e.g., 'megapackv1/filename.mp3')
  // Remove any leading slashes and ensure proper path construction
  const cleanPath = path.replace(/^\/+/, '');
  return getR2Url(`mp3/${cleanPath}`);
};

// Function to get image URL
export const getImageUrl = (filename: string): string => {
  // Remove any leading slashes and ensure proper path construction
  const cleanFilename = filename.replace(/^\/+/, '');
  return getR2Url(`images/${cleanFilename}`);
}; 